import React, { useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from "../context/Authcontext";
import axios from "axios";
import avatar from "../assets/avatar.jpg";
import logo from "../assets/logo.webp";

const Navbar = () => {
  const { contextData } = useContext(AuthContext);
  const { user } = contextData;

  const navigate = useNavigate();

  const gotoprofile = () => {
    navigate(`/profile/${user.user_id}`);
  };

  useEffect(() => {
    getavatar();
  }, []);

  // const getavatar = async () => {
  //   if (contextData.user) {
  //     let response;
  //     try {
  //       response = await axios.get(
  //         `https://pfebackend-zbz0.onrender.com/api/user/avatar/${contextData.user.user_id}/`,
  //         {
  //           responseType: "blob",
  //         }
  //       );
  //       const image = document.getElementById("avatar-image");
  //       const imageUrl = URL.createObjectURL(new Blob([response.data]));
  //       image.src = imageUrl;
  //     } catch (error) {
  //       if (error.response && error.response.status === 500) {
  //         const image = document.getElementById("avatar-image");
  //         image.src = avatar;
  //       }
  //       return;
  //     }
  //   }
  // };
  const getavatar = async () => {
    if (contextData.user) {
      let response;
      try {
        response = await axios.get(
          `https://pfebackend-zbz0.onrender.com/api/user/avatar/${contextData.user.user_id}/`
        );
        const image = document.getElementById("avatar-image");
        // const imageUrl = URL.createObjectURL(new Blob([response.data]));
        image.src = response.data.avatar;
      } catch (error) {
        if (error.response && error.response.status === 500) {
          const image = document.getElementById("avatar-image");
          image.src = avatar;
        }
        return;
      }
    }
  };

  return (
    <nav id="navnav" className="custom-navbar">
      <a className="navbar-brand" href="/">
        <img className="navbar-logo" src={logo} alt="" />
      </a>
      <div className="custom-navbar-collapse">
        <ul className="navbar-nav">
          <li className="nav-item active">
            <Link className="nav-link" to={"/"}>
              Home <span className="sr-only"></span>
            </Link>
          </li>

          <li className="nav-item active">
            <Link className="nav-link" to={"/formations"}>
              All trainings <span className="sr-only"></span>
            </Link>
          </li>

          <li className="nav-item">
            <Link className="nav-link" to={"/formation"}>
              My trainings
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to={"#"}>
              About us
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to={"#"}>
              Contact
            </Link>
          </li>
          {user ? (
            <li className="nav-item">
              <button className="nav-link" onClick={contextData.logoutuser}>
                Log out
              </button>
            </li>
          ) : (
            <>
              <li className="nav-item">
                <Link className="nav-link" to={"/login"}>
                  Login
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to={"/register"}>
                  Register
                </Link>
              </li>
            </>
          )}
          {contextData.user &&
            (contextData.user.role === "admin" ||
              contextData.user.role === "teacher") && (
              <li className="nav-item">
                <Link className="nav-link" to={"/createformation"}>
                  Create
                </Link>
              </li>
            )}
        </ul>
      </div>
      <div className="nav-item">
        <img
          onClick={gotoprofile}
          style={{ maxWidth: "60px" }}
          src=""
          id="avatar-image"
          alt=""
        />
      </div>
    </nav>
  );
};

export default Navbar;
